/**
 * Korean
 *
 */

const locale = {
	"Permission Management": "유저권한",
	header: {
		"Change Language": "언어변환",
		"Premium Version": "유료버전 전환",
		sidemenu: {
			"My channel": "나의 채널",
			"Class Schedule": "클라스 스케쥴",
			"Student": "학생",
			"Class": "클라스",
			"Private Class": "개인클라스",
			"Teacher": "교사",
			"Classroom": "교실",
			"Announcement": "공고",
			"Statement Detail": "명세서세부정보",
			"Monthly Summary": "월별개요",
			"School Management": "학교관리",
			"School Administration": "권한관리",
			"School Information": "학교정보",
			"Sales Management": "영업관리",
		}
	},
	schoolInformation: {
		"School Information": "학교기본정보",
		"Complete all information that helps your audience understand better on the Yellow Pages": "입력하신 정보는 학교 소개 웹사이트에 사용됩니다.",
		form: {
			"School Name": "학교 이름",
			"School Logo": "학교 로고",
			"School Home Page": "홈페이지",
			"Time Zone": "시간대",
			"Currency": "화폐종류",
			"Phone": "전화번호",
			"Email": "이메일",
			"School Type": "학교종류",
			"Category": "클라스종류",
			"Student Age": "학생연령대",
		}	
	}
}

export default locale



// WEBPACK FOOTER //
// ./src/locale/translations/KR.js